module.exports = __webpack_public_path__ + "static/images/smartspot-performance-de-DE.c02851567857513ae623313f91068753.png";